import "../../_css/CustomButtom.css"

function CustomButton({ text, onClick, fontSize = "14px", disabled = false }) {
    return (
        <button style={{ fontSize }} className="custom-btn" onClick={onClick} disabled={disabled}>
            {text}
        </button>
    )
}

export default CustomButton